import { TrackingHandler } from '../tracking/TrackingHandler';
import { processLogin } from '../helpers/login';
import { generateUuid } from '../helpers/strings';
const RESET_PASSWORD_PATH = window.pageUrls.resetPassword || '/passwort-setzen';
const startLoginFormCallback = () => {
    TrackingHandler.getInstance().setCustomer();
};
const handleResponse = async (response, callbackData) => {
    try {
        const responseData = await response.json();
        if (response.ok && responseData.result === 'success') {
            showResultStep(callbackData);
            return;
        }
    }
    catch (e) { }
    showFormErrorMessage(callbackData);
};
const showFormErrorMessage = (callbackData) => {
    callbackData.formContainer.querySelector('.submit-error-message').classList.remove('js-hidden');
    callbackData.formContainer.querySelector('button').removeAttribute('disabled');
};
const showResultStep = (callbackData) => {
    callbackData.currentStep.classList.add('js-hidden');
    callbackData.resultStep.classList.remove('js-hidden');
};
const submitLoginFormCallback = (callbackData) => {
    const headers = typeof callbackData.formContainer.dataset.origin === 'undefined'
        ? {}
        : { 'x-alternate-origin': callbackData.formContainer.dataset.origin };
    processLogin(callbackData.data.username, callbackData.data.password, TrackingHandler.getInstance().visitorId || generateUuid(), headers, callbackData.formContainer.dataset.loginDomain || null).catch((reason) => {
        if (typeof reason === 'string' && reason === 'twofactor_code_missing') {
            const twofactorLoginForm = callbackData.formContainer.nextElementSibling;
            if (twofactorLoginForm && twofactorLoginForm.classList.contains('two-factor-login-form')) {
                callbackData.formContainer.classList.toggle('u-hidden', true);
                twofactorLoginForm.classList.toggle('u-hidden', false);
                return false;
            }
        }
        showFormErrorMessage(callbackData);
    });
    return false;
};
const submit2FALoginFormCallback = (callbackData) => {
    const loginForm = callbackData.formContainer.previousElementSibling;
    const usernameField = loginForm?.querySelector('input[name="username"]');
    const passwordField = loginForm?.querySelector('input[name="password"]');
    if (!usernameField || !passwordField) {
        console.error('Username / password fields not found');
        return false;
    }
    const headers = typeof callbackData.formContainer.dataset.origin === 'undefined'
        ? {}
        : { 'x-alternate-origin': callbackData.formContainer.dataset.origin };
    processLogin(usernameField.value, passwordField.value, TrackingHandler.getInstance().visitorId || generateUuid(), headers, callbackData.formContainer.dataset.loginDomain || null, callbackData.data.code).catch(() => {
        showFormErrorMessage(callbackData);
    });
    return false;
};
const submitForgotPasswordFormCallback = (callbackData) => {
    const headers = typeof callbackData.formContainer.dataset.origin === 'undefined'
        ? {}
        : { 'x-alternate-origin': callbackData.formContainer.dataset.origin };
    fetch(window.endpoints.forgotPassword, {
        method: 'POST',
        body: JSON.stringify({
            sendVia: callbackData.data.method,
            username: callbackData.data.username,
            targetURL: RESET_PASSWORD_PATH,
        }),
        headers,
    })
        .then(async (response) => handleResponse(response, callbackData))
        .catch(() => {
        showFormErrorMessage(callbackData);
    });
    return false;
};
const submitForgotUsernameFormCallback = (callbackData) => {
    const headers = typeof callbackData.formContainer.dataset.origin === 'undefined'
        ? {}
        : { 'x-alternate-origin': callbackData.formContainer.dataset.origin };
    fetch(window.endpoints.forgotUsername, {
        method: 'POST',
        body: JSON.stringify({
            sendVia: callbackData.data.emailOrMobile.indexOf('@') !== -1 ? 'email' : 'SMS',
            target: callbackData.data.emailOrMobile,
        }),
        headers,
    })
        .then(async (response) => handleResponse(response, callbackData))
        .catch(() => {
        showFormErrorMessage(callbackData);
    });
    return false;
};
const submitResetPasswordFormCallback = (callbackData) => {
    const headers = typeof callbackData.formContainer.dataset.origin === 'undefined'
        ? {}
        : { 'x-alternate-origin': callbackData.formContainer.dataset.origin };
    fetch(window.endpoints.resetPassword, {
        method: 'POST',
        body: JSON.stringify({
            uid: callbackData.data.uid,
            password: callbackData.data.newPassword,
        }),
        headers,
    })
        .then(async (response) => handleResponse(response, callbackData))
        .catch(() => {
        showFormErrorMessage(callbackData);
    });
    return false;
};
export const loginCallbacks = {
    startLoginFormCallback,
    submitLoginFormCallback,
    submit2FALoginFormCallback,
    submitForgotPasswordFormCallback,
    submitForgotUsernameFormCallback,
    submitResetPasswordFormCallback,
};
